
import React, { useEffect, useMemo, useState } from "react";
import {
  FaInstagram,
  FaFacebookF,
  FaYoutube,
  FaXTwitter,
  FaEnvelope,
  FaPhone,
  FaWhatsapp,
  FaIndianRupeeSign,
} from "react-icons/fa6";
import {
  FALLBACK_GOLD_RATE_PER_GRAM,
  GOLD_RATE_API_URL,
  formatGoldRate,
} from "../../config/goldRate";

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navLinks = useMemo(
    () => [
      { href: "https://g1gold.com/", label: "Home" },
      { href: "https://g1gold.com/about-us", label: "About Us" },
      { href: "https://g1gold.com/howitworks", label: "How It Works" },
      { href: "https://g1gold.com/services", label: "Services" },
      { href: "https://g1gold.com/why-g1-gold", label: "Why G1 Gold" },
      { href: "https://g1gold.com/gold-calculator", label: "Gold Calculator" },
    ],
    []
  );

 const phoneNumber = "7996800900";
const phoneE164 = "+917996800900";
const phoneDisplay = "+91 7996 800 900";

const landlineE164 = "+918041701696";


const email = "g1goldcompany@gmail.com";
const whatsappNumber = phoneE164.replace("+", "");

const [goldRate, setGoldRate] = useState(
  FALLBACK_GOLD_RATE_PER_GRAM
);

useEffect(() => {
  const controller = new AbortController();

  const fetchGoldRate = async () => {
    try {
      const response = await fetch(
        `${GOLD_RATE_API_URL}?v=${Date.now()}`,
        {
          cache: "no-store",
          headers: { Accept: "application/json" },
          signal: controller.signal,
        }
      );

      if (!response.ok) {
        throw new Error(`API returned ${response.status}`);
      }

      const data = await response.json();
      const rate = Number(data.ratePerGram);

      if (data.success && Number.isFinite(rate) && rate > 0) {
        setGoldRate(rate);
      }
    } catch (error) {
      if (error.name !== "AbortError") {
        console.error("Gold rate could not be loaded:", error);
      }
    }
  };

  fetchGoldRate();

  const interval = window.setInterval(fetchGoldRate, 60000);

  return () => {
    controller.abort();
    window.clearInterval(interval);
  };
}, []);

  return (
    <header className="sticky top-0 z-50 w-full">
      <style>{`
  @media (max-width: 767px) {
    @keyframes g1MobileGoldMarquee {
      0% {
        transform: translateX(0);
      }

      100% {
        transform: translateX(-50%);
      }
    }

    .g1-mobile-gold-marquee {
      animation: g1MobileGoldMarquee 10s linear infinite;
      will-change: transform;
    }
  }

  @media (min-width: 768px) {
    .g1-mobile-gold-marquee {
      animation: none;
    }
  }
`}</style>

      {/* Top Gold Contact Strip */}
{/* Top Gold Contact Strip */}
<div className="relative overflow-hidden bg-gradient-to-r from-[#F8E7B5] via-[#E8CB74] to-[#E2C15F] text-[#3B2A0A] border-b border-[#D4AF37]/35 shadow-sm">
  
{/* DESKTOP ONLY */}
          <div className="relative z-[2] hidden md:flex max-w-7xl mx-auto px-4 md:px-6 h-11 md:h-12 items-center justify-between gap-3">
           {/* Left side */}
<div className="flex items-center gap-3 md:gap-5 text-[11px] sm:text-xs md:text-sm font-semibold min-w-0">
  <a
  href={`tel:${phoneE164}`}
  className="flex items-center gap-1.5 md:gap-2 hover:text-[#7A4E00] transition-all duration-300 hover:-translate-y-[1px] whitespace-nowrap"
  aria-label="Call us"
>
  <FaPhone className="text-[11px] md:text-sm" />
  <span>{phoneDisplay}</span>
</a>


 
  <a
    href={`mailto:${email}`}
    className="hidden sm:flex items-center gap-1.5 md:gap-2 hover:text-[#7A4E00] transition-all duration-300 hover:-translate-y-[1px] whitespace-nowrap"
    aria-label="Email us"
  >
    <FaEnvelope className="text-[11px] md:text-sm" />
    <span className="truncate max-w-[180px] md:max-w-none">
      {email}
    </span>
  </a>

  <a
    href={`https://wa.me/${whatsappNumber}`}
    target="_blank"
    rel="noopener noreferrer"
    className="hidden md:flex items-center gap-1.5 md:gap-2 hover:text-[#7A4E00] transition-all duration-300 hover:-translate-y-[1px] whitespace-nowrap"
    aria-label="Chat on WhatsApp"
  >
    <FaWhatsapp className="text-[12px] md:text-sm" />
    <span>WhatsApp</span>
  </a>
</div>
 
            {/* Right side */}
            <div className="flex items-center gap-1.5 md:gap-2 shrink-0">
              <a
                href="https://www.facebook.com/profile.php?id=61580697385603"
                target="_blank"
                rel="noopener noreferrer"
                className="w-6 h-6 md:w-7 md:h-7 rounded-full bg-white/25 border border-[#B8860B]/25 hover:bg-white/45 hover:border-[#9C6B10]/40 hover:shadow-[0_4px_14px_rgba(184,134,11,0.18)] hover:-translate-y-[1px] flex items-center justify-center transition-all duration-300"
                aria-label="Facebook"
              >
                <FaFacebookF className="text-[10px] md:text-xs" />
              </a>
 
              <a
                href="https://www.instagram.com/g__one_gold/?hl=en"
                target="_blank"
                rel="noopener noreferrer"
                className="w-6 h-6 md:w-7 md:h-7 rounded-full bg-white/25 border border-[#B8860B]/25 hover:bg-white/45 hover:border-[#9C6B10]/40 hover:shadow-[0_4px_14px_rgba(184,134,11,0.18)] hover:-translate-y-[1px] flex items-center justify-center transition-all duration-300"
                aria-label="Instagram"
              >
                <FaInstagram className="text-[10px] md:text-xs" />
              </a>
 
              <a
                href="https://x.com/G1goldcompany"
                target="_blank"
                rel="noopener noreferrer"
                className="w-6 h-6 md:w-7 md:h-7 rounded-full bg-white/25 border border-[#B8860B]/25 hover:bg-white/45 hover:border-[#9C6B10]/40 hover:shadow-[0_4px_14px_rgba(184,134,11,0.18)] hover:-translate-y-[1px] flex items-center justify-center transition-all duration-300"
                aria-label="X"
              >
                <FaXTwitter className="text-[10px] md:text-xs" />
              </a>
 
              <a
      href={`mailto:${email}`}
                className="w-6 h-6 md:w-7 md:h-7 rounded-full bg-white/25 border border-[#B8860B]/25 hover:bg-white/45 hover:border-[#9C6B10]/40 hover:shadow-[0_4px_14px_rgba(184,134,11,0.18)] hover:-translate-y-[1px] flex items-center justify-center transition-all duration-300"
                aria-label="Email"
              >
                <FaEnvelope className="text-[10px] md:text-xs" />
              </a>
 
              <a
                href="https://www.youtube.com/@g-onegoldcompany"
                target="_blank"
                rel="noopener noreferrer"
                className="w-6 h-6 md:w-7 md:h-7 rounded-full bg-white/25 border border-[#B8860B]/25 hover:bg-white/45 hover:border-[#9C6B10]/40 hover:shadow-[0_4px_14px_rgba(184,134,11,0.18)] hover:-translate-y-[1px] flex items-center justify-center transition-all duration-300"
                aria-label="YouTube"
              >
                <FaYoutube className="text-[10px] md:text-xs" />
              </a>
            </div>
          </div>
          {/* MOBILE MOVING GOLD RATE STRIP ONLY */}
<div className="relative z-[2] md:hidden h-10 flex items-center overflow-hidden px-3">
<div className="g1-mobile-gold-marquee flex min-w-max items-center gap-4 whitespace-nowrap text-[#4A3410]">
    
    {[1, 2, 3, 4].map((item) => (
      <div key={item} className="flex items-center gap-4">
        <span className="inline-flex items-center gap-1.5 rounded-full border border-white/35 bg-white/15 px-4 py-1.5 text-[#4A3410] shadow-[inset_0_1px_0_rgba(255,255,255,0.35)]">
          <span className="inline-flex h-[18px] w-[18px] items-center justify-center rounded-full bg-[#FFF6D8] text-[#9C6B10] shadow-sm">
            <FaIndianRupeeSign className="text-[9px]" />
          </span>

          <span className="text-[10px] font-black uppercase leading-none tracking-[0.14em]">
            Today&apos;s Gold Rate
          </span>

          <span className="h-[14px] w-px bg-[#9C6B10]/35" />

          <span className="flex items-baseline gap-[2px] text-[13px] font-black leading-none tracking-[-0.02em] text-[#7A4E00]">
          {formatGoldRate(goldRate)}
            <span className="text-[9px] font-bold tracking-normal text-[#8B5E00]">
              /g
            </span>
          </span>
        </span>

        <span className="text-[#A87918]/55">|</span>
      </div>
    ))}
  </div>
</div>

  {/* MOBILE ONLY */}

</div>

      {/* Main White Navbar */}
      <div className="w-full border-b border-[#efe5c7] bg-white/95 backdrop-blur-md">
        <div className="mx-auto max-w-7xl px-4 md:px-6 py-3 md:py-4">
          <div className="flex items-center justify-between">

            {/* Logo */}
            <a href="https://g1gold.com/" className="flex items-center gap-3">
              <img
                src="/images/logo/g1gold-color-logo.webp"
                alt="G1 Gold Icon"
                width="752"
                height="904"
                sizes="(max-width: 767px) 32px, 40px"
                className="h-8 md:h-10 w-auto"
              />
              <img
                src="/images/logo/g1gold-color-name.webp"
                alt="G1 Gold"
                width="1700"
                height="404"
                sizes="(max-width: 767px) 24px, 32px"
                className="h-6 md:h-8 w-auto"
              />
            </a>

            {/* Desktop Menu */}
            <nav className="hidden md:flex items-center gap-8">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="text-gray-700 font-medium transition-colors hover:text-[#c89b2b]"
                >
                  {link.label}
                </a>
              ))}

              <a
                href="https://g1gold.com/contact-us"
                className="rounded-full px-5 py-2.5 text-sm font-semibold text-white shadow-lg transition md:px-6 md:text-base"
                style={{
                  background: "linear-gradient(135deg, #EFCB57 0%, #C89B2B 100%)",
                }}
              >
                Contact Us
              </a>
            </nav>

            {/* Mobile Menu Button */}
            <button
              type="button"
              onClick={() => setMobileMenuOpen((prev) => !prev)}
              className="md:hidden rounded-lg p-2"
              aria-label="Toggle menu"
              aria-expanded={mobileMenuOpen}
              aria-controls="landing-mobile-nav"
            >
              <svg
                className="w-6 h-6 text-gray-700"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            </button>

          </div>

          {/* Mobile Menu */}
          {mobileMenuOpen && (
            <div
              id="landing-mobile-nav"
              className="md:hidden mt-4 border-t border-[#efe5c7] pt-4 pb-2"
            >
              <div className="flex flex-col gap-4">
                {navLinks.map((link) => (
                  <a
                    key={link.href}
                    href={link.href}
                    onClick={() => setMobileMenuOpen(false)}
                    className="text-gray-700 font-medium hover:text-[#c89b2b]"
                  >
                    {link.label}
                  </a>
                ))}

                <a
                  href="https://g1gold.com/contact"
                  onClick={() => setMobileMenuOpen(false)}
                  className="rounded-full px-6 py-3 text-center font-semibold text-white shadow-lg transition"
                  style={{
                    background: "linear-gradient(135deg, #EFCB57 0%, #C89B2B 100%)",
                  }}
                >
                  Contact Us
                </a>
              </div>
            </div>
          )}

        </div>
      </div>

      

    </header>
  );
};

export default Header;